import { render } from "./JoinPublicationPrivatePublication.vue.js?vue&type=template&id=176521ab!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationPrivatePublication.vue?vue&type=template&id=176521ab"
import script from "./JoinPublicationPrivatePublication.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationPrivatePublication.vue?vue&type=script&lang=js"
export * from "./JoinPublicationPrivatePublication.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationPrivatePublication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/JoinPublicationPrivatePublication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "176521ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('176521ab', __exports__)) {
    api.reload('176521ab', __exports__)
  }
  
  module.hot.accept("./JoinPublicationPrivatePublication.vue.js?vue&type=template&id=176521ab!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationPrivatePublication.vue?vue&type=template&id=176521ab", () => {
    api.rerender('176521ab', render)
  })

}


export default __exports__